module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": "详情"
    }
  }, [_c('div', [_c('el-table', {
    attrs: {
      "data": _vm.currentInfo,
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "label"
    }
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: {
      default: function(scope) {
        return [(scope.$index === 0) ? _c('span', [_vm._v(_vm._s(scope.row.name))]) : _vm._e(), _vm._v(" "), _vm._v(" "), (scope.$index === 1) ? _c('span', [_vm._v(_vm._s(scope.row.position))]) : _vm._e(), _vm._v(" "), _vm._v(" "), (scope.$index === 2) ? _c('span', [_vm._v(_vm._s(scope.row.structure))]) : _vm._e(), _vm._v(" "), _vm._v(" "), (scope.$index === 3) ? _c('span', [_vm._v(_vm._s(scope.row.mobile))]) : _vm._e(), _vm._v(" "), _vm._v(" "), (scope.$index === 4) ? _c('div', {
          staticClass: "mh-270 ovf-auto"
        }, _vm._l((scope.row.leave_list), function(option) {
          return _c('div', {
            staticClass: "m-b-5"
          }, [_c('span', {
            staticStyle: {
              "font-weight": "800"
            }
          }, [_vm._v(_vm._s(option.type) + ":")]), _c('span', [_vm._v(_vm._s(option.hours))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.start))]), _vm._v("~"), _c('span', [_vm._v(_vm._s(option.end))])])
        })) : _vm._e()]
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e1dceed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Self/leaveInfoDialog.vue
// module id = 1942
// module chunks = 2